import { useState } from "react";

export function useFormFields(initialState, initialMessages) {
  const [fields, setValues] = useState(initialState);
  const [messages, setMessages] = useState(initialMessages);

  function validationResult(messageId, text) {
      document.getElementById(messageId).textContent=text;
  }
  const doValidation = () => {
    console.log('doValidation...');
    let valid = true;
    for (const k in messages) {
          console.log(`${k}: ${messages[k]}`);
          const validator = messages[k].f;
          console.log(fields[k]);
          const msg = validator(fields[k]);
          if ("" !== msg) {
              messages[k].n = msg;
              valid = false;
          } else {
              messages[k].n = "";
          }
          console.log(msg);
          console.log('valid?? ' + (valid ? 'true' : 'false'));
//        }
    }
    return valid;
  };

  return [
    fields,
    messages,
    function(event) {
      console.log('caall f...');
      console.log('event target value = ' + event.target.value);
      console.log(messages);
      let myId = event.target.id;
      console.log("id = " + myId);
      if (!myId) {
          console.log('name = ' + event.target.name);
          myId = event.target.name;
          return;
      }
      if (!myId) {
          console.log('no id and name');
          return;
      }

      const validator = messages[myId].f;
      console.log(messages[myId].n);
      console.log(validator);
      const vMsg = validator(event.target.value);
      const val = ("checkbox" == event.target.type) ? (event.target.checked ? event.target.value : 0 ): event.target.value;
      console.log(val);
      setValues({
        ...fields,
        [myId]: val
      });
      setMessages({
        ...messages,
        [myId]: { n: vMsg, f: validator }
      });
    },
    doValidation
  ];
}
